import { SkinnableComponent } from '../../../types/component-skin';
import { useMembershipSignupLogic } from './MembershipSignupLogic';
import BasicMembershipSignupSkin from './skins/BasicMembershipSignupSkin';
import { COMPONENT_TYPES } from '../../../constants';

/**
 * 멤버십 가입 스킨 가능 컴포넌트 정의
 */
export const MembershipSignupSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.MEMBERSHIP_SIGNUP,
  name: '멤버십 가입',
  category: 'auth',
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicMembershipSignupSkin as any
  },
  useLogic: useMembershipSignupLogic as any,
  defaultProps: {
    title: '멤버십 가입신청',
    productId: 0,
    buttonText: '가입 신청',
    completedText: '가입 완료',
    description: '멤버십에 가입하시면 다양한 혜택을 받으실 수 있습니다.',
    buttonColor: '#007bff',
    titleColor: '#333333',
    descriptionColor: '#666666',
    componentProps: {
      skin: 'basic',
      title: '멤버십 가입신청',
      productId: 0,
      buttonText: '가입 신청',
      completedText: '가입 완료',
      description: '멤버십에 가입하시면 다양한 혜택을 받으실 수 있습니다.'
    }
  }
};